<template>
  <div class="company-viriffed-bd">
    <div class="header">
      <div class="center-content">
        <div class="icon"></div>
        <div class="title">{{$t('crm_company_verified.smrzsp')}}</div>
      </div>
    </div>
    <div class="viriffed-box">
      <div class="tip">
        <i class="icon icon-tishi"></i>
        <span>{{$t('crm_company_verified.qzxhdyxxx')}}</span>
      </div>
      <template v-if="false">
        <div class="base-item">
          <div class="title">{{$t('crm_company_verified.ji_chu_xin_xi')}}</div>
          <div class="row">
            <div class="col">
              <div class="key">{{$t('crm_company_verified.gong_si_ming_cheng')}}</div>
              <div class="val">{{ data.partnerName }}</div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="key">{{$t('crm_company_verified.tyshxydmyyzzbh')}}</div>
              <div class="val">{{ data.businessLicense }}</div>
            </div>
            <div class="col">
              <div class="key">{{$t('crm_company_verified.nsrsbhswdjbh')}}</div>
              <div class="val">{{ data.buyerNumber }}</div>
            </div>
            <div class="col">
              <div class="key">{{$t('crm_company_verified.fa_ren_xing_ming')}}</div>
              <div class="val">{{ data.legalPerson }}</div>
            </div>
            <div class="col">
              <div class="key">{{$t('crm_company_verified.frsfzh')}}</div>
              <div class="val">{{ data.legalPersonIdentity }}</div>
            </div>
          </div>
        </div>
      </template>
      <verfied-detail-base :data="data"  v-if="data.enterpriseType===1 || data.enterpriseType===2" > </verfied-detail-base>
      <verfied-detail-institutions :data="data" v-if="data.enterpriseType===3" > </verfied-detail-institutions>
      <verfied-detail-religion :data="data"  v-if="data.enterpriseType===4" > </verfied-detail-religion>
      <div class="base-item" v-if="data.realnameBo">
          <div class="title">{{$t('crm_company_verified.qysmrzxx')}}</div>
          <div class="row" >
            <div class="col">
              <div class="key">{{$t('crm_company_verified.jbrxm')}}</div>
              <div class="val">{{ data.realnameBo.legalAgent }}</div>
            </div>
            <div class="col">
              <div class="key">{{$t('crm_company_verified.jbrsjh')}}</div>
              <div class="val">{{ data.realnameBo.legalAgentMobile }}</div>
            </div>
            <div class="col">
              <div class="key">{{$t('crm_company_verified.jbrsfzh')}}</div>
              <div class="val">{{ data.realnameBo.legalAgentIdentity }}</div>
            </div>
            <div class="col">
              <div class="key">{{$t('crm_company_verified.qysqzs')}}</div>
              <div class="val">
                <span class="detail" @click="visible = true">{{$t('Common.com_detail')}}</span>
              </div>
            </div>
          </div>
        </div>

      <el-form class="form" :model="form" :inline="true" ref="form" label-width="120px" label-position="top">
        <el-row>
            <el-col :span="24">
              <el-form-item :label="$t('crm_company_verified.spsftg')" prop="isApprove" :rules="rules.isApprove">
                <el-radio-group v-model="form.isApprove">
                  <el-radio :label="1">{{$t('crm_company_verified.tong_guo')}}</el-radio>
                  <el-radio :label="0">{{$t('crm_company_verified.bu_tong_guo')}}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        <el-row>
          <!-- <el-col :span="24">
            <el-form-item label="审批是否通过:" prop="isApprove" :rules="rules.isApprove">
              <el-switch v-model="form.isApprove"></el-switch>
            </el-form-item>
          </el-col> -->
          <el-col :span="24">
            <el-form-item :label="$t('crm_company_verified.shen_pi_yi_jian')" prop="remark" :rules="form.isApprove?[]:rules.remark">
              <el-input
                :rows="3"
                type="textarea"
                v-model="form.remark"
                :placeholder="$t('crm_company_verified.qtxbtgyy')"
                style="width:900px;"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="footer">
        <el-button @click="savejump">
          {{
          $t('Common.com_close')
          }}
        </el-button>
        <el-button type="primary" @click="saveApprove">{{$t('Common.com_confirm')}}</el-button>
      </div>
    </div>


    <img-detail-dialog
      :bizData="authorizationData"
      :title="$t('crm_company_verified.qysqzs')"
      v-if="visible"
      @close="visible = false"
    ></img-detail-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import verfiedDetailBase from './partner_verified_detail_base.vue';
import verfiedDetailInstitutions from './partner_verified_detail_institutions.vue';
import verfiedDetailReligion from './partner_verified_detail_religion.vue';

export default {
  name: 'renter_verified',
  components: {
    verfiedDetailBase,
    verfiedDetailInstitutions,
    verfiedDetailReligion
  },
  data() {
    return {
      // 授权书
      visible: false,
      data: [],

      // 用于编辑
      form: {
        // 合作伙伴
        partnerId: '',
        // partnerOrgId: '',
        // adminId: '',
        isApprove: 1,
        remark: '',
      },
      partnerId: '',
      // 实名证书id
      realNameId: '',
      authorizationImg: {},
    };
  },
  computed: {
    rules() {
      return {
        isApprove: [{ required: true, message: this.$t('crm_company_verified.qxzsftg') }],
        remark: [
          { required: true, message: this.$t('crm_company_verified.qtxbtgyy') },
          { max: 200, message: this.$t('Common.com_rules_length_max', [200]), },
        ],
      };
    },
    // 授权书biz数据
    authorizationData() {
      return [
        {
          bizId: this.realNameId,
          bizType: 'certificateOfAuthorization'
        }
      ];
    }
  },
  mounted() {
    // 获取id
    this.partnerId = this.getJump('companyId');
    this.getCompanyDetail();
    // 清除缓存
    this.clearKeepAlive('renter');
  },
  methods: {
    getCompanyDetail: function () {
      this.$getJSON(apis.partnerInfoAndReal, { partnerId: this.partnerId }).then(
        (res) => {
          this.data = res.data;
          this.realNameId = res.data.realnameBo.realNameId || '';
        }
      );
    },
    // 审批实名认证
    saveApprove() {
      this.form.partnerId = this.partnerId;
      if (this.form.isApprove) {
        this.$postJSON(apis.companyAuthApprovalYesAgent, this.form).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          this.$emit('success');
          this.savejump();
        });
      } else {
        this.$postJSON(apis.companyAuthApprovalNoAgent, this.form).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          this.$emit('success');
          this.savejump();
        });
      }
    },
    savejump() {
      this.clearTagByKeep('renter_verified');
      const parentPath = this.getJump('parentPath');
      if (parentPath) {
        this.jump(parentPath, {}, true);
        return;
      }
      // partnerType HQ-总部，SC-售后公司，JV-代理，CO-大客户，CS-客户
      switch (this.data.partnerType) {
        case 'HQ':
          this.jump('/distributor/factory');
          break;
        case 'CS':
          this.jump('/customer/renter');
          break;
        case 'CO':
          this.jump('/customer/groupCustomer');
          break;
        default:
          this.jump('/distributor/serviceCompany');
      }

    }
  },
};
</script>

<style lang="scss">
.company-viriffed-bd {
  background: #ffffff;
  min-height: 100%;
  .header {
    // height: 100px;
    background: linear-gradient(
      180deg,
      rgba(74, 186, 241, 1) 0%,
      rgba(61, 174, 230, 1) 100%
    );
    width: 100%;

    .center-content {
      height: 100px;
      width: 900px;
      margin: 0 auto;
      background-image: url("~@/images/layout/identification_header_bg.png");
      background-position: bottom;
      background-repeat: no-repeat;
      background-size: 100%;
      padding-top: 36px;
    }

    .icon {
      $r: 32px;
      width: $r;
      height: $r;
      background-image: url("~@/images/layout/icon_qi.png");
      background-size: 100%;
      background-repeat: no-repeat;
      float: left;
      margin-left: 361px;
      // margin-top: 34px;
    }

    .title {
      font-size: 22px;
      color: #fff;
      line-height: 32px;
      float: left;
      margin-left: 14px;
      // margin-top: 34px;
      font-weight: 500;
      letter-spacing: 2px;
    }
  }
  .viriffed-box {
    width: 900px;
    margin: 0 auto;
    // background-color: #fafafa;
    .tip {
      margin: 24px 0 16px;
      background: rgba(13, 154, 224, 0.15);
      margin-bottom: 16px;
      padding-left: 10px;
      .icon {
        color: #0d9ae0;
        font-size: 12px;
        margin-right: 10px;
      }
      span {
        line-height: 32px;
        color: #6c757d;
        font-size: 12px;
      }
    }
    .base-item {
      background: #fafafa;
      font-size: 12px;
      padding-bottom: 24px;
      padding-left: 24px;
      border-bottom: 1px solid #eef2f8;
      // &:nth-child(n + 2) {
      //   margin-top: 7px;
      // }
      overflow: hidden;
      .title {
        color: #0d9ae0;
        font-weight: bold;
        line-height: 16px;
        margin-top: 24px;
      }
      .row {
        overflow: hidden;
        // display: flex;
        .col {
          float: left;
          width: 201px;
          // flex: 1;
          margin: 24px 16px 0 0;
          &.long {
            width: 100%;
          }
          .key {
            color: #98a6ad;
            line-height: 16px;
          }
          .val {
            margin-top: 8px;
            font-weight: bold;
            color: #495057;
          }
          .detail {
            color: #0d9ae0;
            text-decoration: underline;
            cursor: pointer;
          }
        }
      }

      .table-bd {
        margin-top: 24px;
      }
    }
    .form{
      margin-top: 24px;
    }
    .footer{
      margin-top: 16px;
      padding-top: 15px;
      border-top:1px solid #EEF2F8;
      text-align: center;
    }
  }

  // .title {
  //   // height: 18px;
  //   font-size: 12px;
  //   font-weight: bold;
  //   color: #0D9AE0;
  //   line-height: 18px;
  //   padding: 24px 0 16px;
  // }
}
</style>
